import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Claim } from '../_models/claim.model';
import { QuoteLife, Quote, QuoteDocuments } from '../_models/quote.model';;
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

const DEFAULT_STATE: ITableState = {
	filter: {},
	paginator: new PaginatorState(),
	sorting: new SortState(),
	searchTerm: '',
	grouping: new GroupingState(),
	entityId: undefined,
	paramsGet: "",
	paramsPost: {}
  };
  
  @Injectable({
	providedIn: 'root'
  })

export class ListClaimsService extends TableService<Claim> implements OnDestroy {

	apiUrls = {
        getClaims : `${environment.url}/${environment.apiUrl}/Reclamos/get_reclamos?`,
	}

	constructor(@Inject(HttpClient) http, private auth: AuthService) {
		super(http);
	}

	// READ
	find(tableState: ITableState): Observable<TableResponseModel<Claim>> {
		return this.http.get<Claim[]>(this.apiUrls.getClaims + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
		  map((response: Claim[]) => {
			const filteredResult = baseFilter(response, tableState);
			const result: TableResponseModel<Claim> = {
			  items: response, // filteredResult.items,
			  total: filteredResult.total
			};
			return result;
		  })
	)}

	extracData(id, claims) {
		var item;
	
		//FEXME
		claims.pipe().subscribe(items => {
		  return items.filter(c => {
			if(c.IdReclamo == id) {
			  return (item = c);
			}
		  });
		});
			
		return item;
	}
	
	ngOnDestroy() {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}
}
